import React, { useState } from 'react';
import _, { capitalize, isEmpty } from 'lodash';
import Grid from '@mui/material/Grid';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import styles from './main.styles.js';
import Dialog from '@mui/material/Dialog';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Person2Icon from '@mui/icons-material/Person2';
import EditUser from '../EditUser/EditUser';
import logo from '../images/logo.png';
import boyImage from '../images/boy.png';
import girlImage from '../images/girl.png';
import { useTranslation } from 'react-i18next';
import ReferalCodeModal from './components/ReferalCodeModal';
import { getSignedImage } from '../utils/index.js';
import userService from '../user.service.js';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';
import './styles.css';
import BlindIcon from '@mui/icons-material/Blind';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ChatIcon from '@mui/icons-material/Chat';
import PeopleIcon from '@mui/icons-material/People';
import DashboardIcon from '@mui/icons-material/Dashboard';

const useStyles = makeStyles()(styles);

const USER_TYPE = {
  device_user: 'DEVICE_USER',
  companion_user: 'COMPANION_USER',
  care_user: 'CARE_USER',
};

function UserInfo({
  user,
  logout,
  refresh,
  canCare = false,
  setMedication,
  setAddCaregiver,
  setChats,
  setAddCane,
  userPortalSettings,
  activeUserId = '1',
}) {
  const history = useNavigate();
  const { t } = useTranslation();
  const { classes } = useStyles();
  const [state, setState] = useState({
    openEditUser: false,
    openReferalModal: false,
    showFullInfo: false,
    showFullInfoText: 'Show Full Info',
  });
  const [userImage, setUserImage] = useState(user?.userInfo?.imageUrl);
  const [unsignedImage, setUnsignedImage] = useState(user?.userInfo?.imageUrl);

  // let userImage = null;
  // userImage = user?.userInfo?.imageUrl;

  React.useEffect(() => {
    if (!userImage) {
      const userImageTemp = (user.userInfo && user.userInfo.gender) === 'female' ? girlImage : boyImage;
      setUserImage(userImageTemp);
    }
  }, []);

  const getImage = React.useCallback(async () => {
    const authData = userService.getAuthData();
    try {
      const { data } = await getSignedImage(authData.currentUserId, unsignedImage);
      setUserImage(data?.data);
    } catch (error) {
      console.log(error);
    }
  }, [unsignedImage]);

  React.useEffect(() => {
    getImage();
  }, [getImage]);

  function closeModal() {
    getImage();
    setState((prevState) => {
      return { ...prevState, openEditUser: false };
    });
  }

  function toggleShowFullInfo() {
    let showFullInfoText = state.showFullInfo ? 'Show full info' : 'Hide full info';

    setState((prevState) => {
      return {
        ...prevState,
        showFullInfo: !state.showFullInfo,
        showFullInfoText,
      };
    });
  }

  const profileImage = (image) => {
    setUnsignedImage(image);
  };

  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      alignItems="center"
      className={classes.userInfoContainer}
      xs={12}
      sm={12}
      md={12}
      lg={3}
    >
      <Grid item className={classes.logoContainer}>
        <img src={logo} alt="CAN logo" className={classes.logo} />
      </Grid>

      <Grid item className={classes.showFullInfoButton} style={{ marginTop: '30px' }} onClick={toggleShowFullInfo}>
        <MenuIcon />
      </Grid>

      {width > 1280 ? (
        <>
          {' '}
          <Grid item className={classes.userImageContainer}>
            <div
              style={{
                backgroundImage: `url(${userImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: '50%',
              }}
              className={classes.userImage}
            ></div>
          </Grid>
          <Grid
            container
            item
            direction="column"
            justify="flex-start"
            alignItems="center"
            className={classes.mainUserInfoContainer}
          >
            {user?.userType === USER_TYPE.companion_user ? (
              <Grid item className={classes.userPhoneNumber}>
                {capitalize(user?.fullName || 'User')}
              </Grid>
            ) : (
              <Grid item className={classes.userPhoneNumber}>
                {!isEmpty(user?.userInfo?.firstName)
                  ? `${user.userInfo && capitalize(user.userInfo.firstName)} ${user.userInfo && user.userInfo.lastName}`
                  : `${user?.fullName}`}
              </Grid>
            )}

            <Grid item className={`${classes.userEmail} ${classes.grayText}`}>
              {user.email}
            </Grid>
          </Grid>
          <Grid container direction="column" justify="flex-start" alignItems="center">
            {canCare && (
              <Grid item className={classes.userEditButtonContainer}>
                {user?.userType !== USER_TYPE.care_user && (
                  <p onClick={() => history('/main')} className="sidebar-nav">
                    <DashboardIcon className="navbar-icon" /> Device Dashboard
                  </p>
                )}
                <p onClick={setAddCane} className="sidebar-nav">
                  <BlindIcon className="navbar-icon" /> Add a new Cane
                </p>
                <p onClick={setMedication} className="sidebar-nav">
                  <MedicalServicesIcon className="navbar-icon" /> Medication Management
                </p>
                <p onClick={setAddCaregiver} className="sidebar-nav">
                  <PeopleIcon className="navbar-icon" />
                  Caregivers
                </p>
                <p onClick={setChats} className="sidebar-nav">
                  <ChatIcon className="navbar-icon" /> Chats
                </p>
                <p
                  onClick={() =>
                    setState((prev) => {
                      return { ...prev, openEditUser: true };
                    })
                  }
                  className="sidebar-nav"
                >
                  <Person2Icon className="navbar-icon" />
                  {activeUserId === '1' ? 'My Profile' : t('profile')}
                </p>
              </Grid>
            )}

            {user?.userType !== USER_TYPE.companion_user && !canCare && (
              <Grid item className={classes.userEditButtonContainer}>
                {userPortalSettings?.canCare === 2 && (
                  <p onClick={() => history('/cancare')} className="sidebar-nav">
                    <DashboardIcon className="navbar-icon" /> CAN Care Dashboard
                  </p>
                )}
                <p onClick={setAddCane} className="sidebar-nav">
                  <BlindIcon className="navbar-icon" /> Add a new Cane
                </p>
                {userPortalSettings?.medicationReminder === 2 && (
                  <p onClick={setMedication} className="sidebar-nav">
                    <MedicalServicesIcon className="navbar-icon" /> Medication Management
                  </p>
                )}
                <p
                  onClick={() =>
                    setState((prev) => {
                      return { ...prev, openEditUser: true };
                    })
                  }
                  className="sidebar-nav"
                >
                  <Person2Icon className="navbar-icon" />
                  {activeUserId === '1' ? 'My Profile' : t('profile')}
                </p>
              </Grid>
            )}
            {user?.userType === USER_TYPE.companion_user && !canCare && (
              <Grid item className={classes.userEditButtonContainer}>
                <p onClick={setAddCane} className="sidebar-nav">
                  <BlindIcon className="navbar-icon" /> Add a new Cane
                </p>
              </Grid>
            )}
            <Grid
              container
              item
              direction="row"
              justify="space-between"
              alignItems="flex-start"
              className={classes.userInfoFooter}
            >
              <Grid item className={classes.supportButtonContainer}>
                <a href="mailto: hi@canmobilities.com" className={`${classes.supportButton} ${classes.grayText}`}>
                  <ContactSupportIcon className={classes.textIcons} />
                  {t('support')}
                </a>
              </Grid>
              <Grid item className={`${classes.logoutButton} ${classes.grayText}`} onClick={logout}>
                <ExitToAppIcon className={classes.textIcons} />
                {t('logout')}
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <Drawer
          open={state.showFullInfo}
          onClose={() =>
            setState((prev) => {
              return { ...prev, showFullInfo: false };
            })
          }
        >
          <div style={{ paddingInline: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'end', margin: '20px' }}>
              <CloseIcon
                onClick={() =>
                  setState((prev) => {
                    return { ...prev, showFullInfo: false };
                  })
                }
              />
            </div>
            <>
              <Grid item className={classes.userImageContainer} style={{ marginInline: 'auto' }}>
                <div
                  style={{
                    backgroundImage: `url(${userImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    backgroundPosition: '50%',
                  }}
                  className={classes.userImage}
                ></div>
              </Grid>
              <Grid
                container
                item
                direction="column"
                justify="flex-start"
                alignItems="center"
                className={classes.mainUserInfoContainer}
              >
                {user?.userType === USER_TYPE.companion_user ? (
                  <Grid item className={classes.userPhoneNumber}>
                    {capitalize(user?.fullName || 'User')}
                  </Grid>
                ) : (
                  <Grid item className={classes.userPhoneNumber}>
                    {!isEmpty(user?.userInfo?.firstName)
                      ? `${user.userInfo && capitalize(user.userInfo.firstName)} ${user.userInfo && user.userInfo.lastName}`
                      : `${user?.fullName}`}
                  </Grid>
                )}

                <Grid item className={`${classes.userEmail} ${classes.grayText}`}>
                  {user.email}
                </Grid>
              </Grid>
              <Grid container direction="column" justify="flex-start" alignItems="center">
                {canCare && (
                  <Grid item className={classes.userEditButtonContainer}>
                    {user?.userType !== USER_TYPE.care_user && (
                      <p onClick={() => history('/main')} className="sidebar-nav">
                        <DashboardIcon className="navbar-icon" /> Device Dashboard
                      </p>
                    )}
                    <p onClick={setAddCane} className="sidebar-nav">
                      <BlindIcon className="navbar-icon" /> Add a new Cane
                    </p>
                    <p onClick={setMedication} className="sidebar-nav">
                      <MedicalServicesIcon className="navbar-icon" /> Medication Management
                    </p>
                    <p onClick={setAddCaregiver} className="sidebar-nav">
                      <PeopleIcon className="navbar-icon" />
                      Caregivers
                    </p>
                    <p onClick={setChats} className="sidebar-nav">
                      <ChatIcon className="navbar-icon" /> Chats
                    </p>
                    <p
                      onClick={() =>
                        setState((prev) => {
                          return { ...prev, openEditUser: true };
                        })
                      }
                      className="sidebar-nav"
                    >
                      <Person2Icon className="navbar-icon" />
                      {activeUserId === '1' ? 'My Profile' : t('profile')}
                    </p>
                  </Grid>
                )}
                {user?.userType !== USER_TYPE.companion_user && !canCare && (
                  <Grid item className={classes.userEditButtonContainer}>
                    {userPortalSettings?.canCare === 2 && (
                      <p onClick={() => history('/cancare')} className="sidebar-nav">
                        <DashboardIcon className="navbar-icon" /> CAN Care Dashboard
                      </p>
                    )}
                    <p onClick={setAddCane} className="sidebar-nav">
                      <BlindIcon className="navbar-icon" /> Add a new Cane
                    </p>
                    {userPortalSettings?.medicationReminder === 2 && (
                      <p onClick={setMedication} className="sidebar-nav">
                        <MedicalServicesIcon className="navbar-icon" /> Medication Management
                      </p>
                    )}
                    <p
                      onClick={() =>
                        setState((prev) => {
                          return { ...prev, openEditUser: true };
                        })
                      }
                      className="sidebar-nav"
                    >
                      <Person2Icon className="navbar-icon" />
                      {activeUserId === '1' ? 'My Profile' : t('profile')}
                    </p>
                  </Grid>
                )}
                {user?.userType === USER_TYPE.companion_user && !canCare && (
                  <Grid item className={classes.userEditButtonContainer}>
                    <p onClick={setAddCane} className="sidebar-nav">
                      <BlindIcon className="navbar-icon" /> Add a new Cane
                    </p>
                  </Grid>
                )}
                <Grid
                  container
                  item
                  direction="row"
                  justify="space-between"
                  alignItems="flex-start"
                  className={classes.userInfoFooter}
                >
                  <Grid item className={classes.supportButtonContainer}>
                    <a href="mailto: hi@canmobilities.com" className={`${classes.supportButton} ${classes.grayText}`}>
                      <ContactSupportIcon className={classes.textIcons} />
                      {t('support')}
                    </a>
                  </Grid>
                  <Grid item className={`${classes.logoutButton} ${classes.grayText}`} onClick={logout}>
                    <ExitToAppIcon className={classes.textIcons} />
                    {t('logout')}
                  </Grid>
                </Grid>
              </Grid>
            </>
          </div>
        </Drawer>
      )}
      <Dialog
        className={classes.modal}
        open={state.openEditUser}
        // fullWidth={true}
        maxWidth={false}
        // onClose={handleClose}
      >
        <EditUser user={user} refresh={refresh} closeModal={closeModal} profileImage={profileImage}></EditUser>
      </Dialog>
      <Dialog className={classes.modal} open={state.openReferalModal} maxWidth={false}>
        <ReferalCodeModal
          user={user}
          closeModal={() =>
            setState((prevState) => {
              return { ...prevState, openReferalModal: false };
            })
          }
        ></ReferalCodeModal>
      </Dialog>
    </Grid>
  );
}

export default UserInfo;
